import { Component, Input } from '@angular/core';

import { IconPosition } from '../../new-button.component';

@Component({
  selector: 'broker-button-x-svg',
  templateUrl: './x-svg.component.svg'
})
export class XSvgComponent {
  @Input() position: IconPosition = 'left';
}
